// Era definitions shared by year slider + result display.

export type EraKey =
  | 'khedival'
  | 'british'
  | 'monarchy'
  | 'nasser'
  | 'sadat'
  | 'mubarak'
  | 'post_2011'

export type EraBand = {
  key: EraKey
  label_en: string
  label_ar: string
  start: number
  end: number  // exclusive
  color: string
}

export const SLIDER_MIN = 1850
export const SLIDER_MAX = 2026

export const ERAS: EraBand[] = [
  { key: 'khedival',  label_en: 'Khedival',  label_ar: 'الخديوية', start: 1850, end: 1882, color: '#7d5a3c' },
  { key: 'british',   label_en: 'British',   label_ar: 'الاحتلال البريطاني', start: 1882, end: 1922, color: '#a07842' },
  { key: 'monarchy',  label_en: 'Monarchy',  label_ar: 'الملكية',  start: 1922, end: 1952, color: '#c79a3a' },
  { key: 'nasser',    label_en: 'Nasser',    label_ar: 'عبد الناصر', start: 1952, end: 1970, color: '#3a7d3a' },
  { key: 'sadat',     label_en: 'Sadat',     label_ar: 'السادات',  start: 1970, end: 1981, color: '#3a627d' },
  { key: 'mubarak',   label_en: 'Mubarak',   label_ar: 'مبارك',    start: 1981, end: 2011, color: '#6e7a85' },
  { key: 'post_2011', label_en: 'Post-2011', label_ar: 'ما بعد ٢٠١١', start: 2011, end: 2026, color: '#b84a4a' },
]

export function eraForYear(year: number): EraBand {
  for (const e of ERAS) if (year >= e.start && year < e.end) return e
  return ERAS[ERAS.length - 1]!
}

/** Build the CSS linear-gradient stops for the era band strip. */
export function eraGradient(): string {
  const stops: string[] = []
  const span = SLIDER_MAX - SLIDER_MIN
  for (const e of ERAS) {
    const left = ((e.start - SLIDER_MIN) / span) * 100
    const right = ((e.end - SLIDER_MIN) / span) * 100
    stops.push(`${e.color} ${left.toFixed(2)}% ${right.toFixed(2)}%`)
  }
  return `linear-gradient(to right, ${stops.join(', ')})`
}
